/* =========================================================
   HG AI Search — FINAL JS (WORKING + Description Search)
   - Modal open/close (desktop + mobile)
   - Close on outside click
   - iOS/Safari ghost click/submit shield (prevents /search redirect)
   - Results = Shopify suggest + HG feed (title + tags + DESCRIPTION)
========================================================= */

(function () {
  "use strict";

  const CFG = {
    overlayId: "hg-ai-overlay",
    modalId: "hg-ai-modal",
    inputSel: "[data-hg-ai-input]",
    openSel: "[data-hg-ai-search-open]",
    closeSel: "[data-hg-ai-close]",
    submitSel: "[data-hg-ai-submit]",
    fileSel: "[data-hg-ai-file]",
    clearImgSel: "[data-hg-ai-clear-img]",
    listSel: "[data-hg-ai-list]",
    emptySel: "[data-hg-ai-empty]",
    countSel: "[data-hg-ai-count]",
    outputSel: "[data-hg-ai-output]",
    statusSel: "[data-hg-ai-status]",
    dotSel: "[data-hg-ai-dot]",
    previewSel: "[data-hg-ai-preview]",
    previewImgSel: "[data-hg-ai-preview-img]",
    previewNameSel: "[data-hg-ai-preview-name]",
    aiShopLinkSel: "[data-hg-ai-shop-link]",
    panelSel: ".hg-ai-panel",
    aiEndpoint: "https://chatbot.hortigo.ro/v1/prompt-create",
    shopBase: "",
    // HG feed endpoint (descriere + tags)
    hgFeedUrl: "/collections/all?view=hg-search",
    hgLimit: 8
  };

  const debounce = (fn, wait) => {
    let t = null;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  const esc = (s) =>
    String(s || "").replace(/[&<>"']/g, (m) =>
      ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;"
      }[m])
    );

  function qs(root, sel) { return root.querySelector(sel); }
  function getModal() { return document.getElementById(CFG.modalId); }
  function getOverlay() { return document.getElementById(CFG.overlayId); }
  function isOpen() {
    const m = getModal();
    return !!(m && m.classList.contains("is-open"));
  }

  let lastActiveEl = null;
  let scrollYBeforeOpen = 0;

  // HARD shield against iOS ghost click/submit
  let shieldUntil = 0;
  const shieldOn = (ms) => { shieldUntil = Date.now() + (ms || 280); }; // 280ms (sa nu blocheze prea mult)
  const shieldActive = () => Date.now() < shieldUntil;

  function lockScroll(on) {
    document.documentElement.classList.toggle("hg-ai-lock", !!on);
    document.body.classList.toggle("hg-ai-lock", !!on);

    if (on) {
      scrollYBeforeOpen = window.scrollY || window.pageYOffset || 0;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollYBeforeOpen}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.width = "100%";
    } else {
      const top = document.body.style.top;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";
      const y = top ? Math.abs(parseInt(top, 10)) : scrollYBeforeOpen;
      window.scrollTo(0, y || 0);
    }
  }

  function ensureShell() {
    if (getModal()) return;

    const overlay = document.createElement("div");
    overlay.id = CFG.overlayId;
    overlay.className = "hg-ai-overlay";
    overlay.setAttribute("aria-hidden", "true");

    const modal = document.createElement("div");
    modal.id = CFG.modalId;
    modal.className = "hg-ai-modal";
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");
    modal.setAttribute("aria-label", "Căutare inteligentă Hortigo");

    modal.innerHTML = `
      <div class="hg-ai-panel" data-hg-ai-root>
        <div class="hg-ai-top">
          <div class="hg-ai-badge"><i></i> HG AI Search</div>
          <div class="hg-ai-hint">
            <span class="hg-ai-kbd">Esc</span> închide
            <span class="hg-ai-kbd">Enter</span> caută
          </div>
        </div>

        <div class="hg-ai-inputRow">
          <div class="hg-ai-inputWrap">
            <svg class="hg-ai-ico" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M10 18a8 8 0 1 1 5.3-14.1A8 8 0 0 1 10 18zm11 3-6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <input class="hg-ai-input" type="search" autocomplete="off"
              placeholder="Scrie: produs, problemă, cultură… (ex: afide la măr)"
              data-hg-ai-input
            />
          </div>

          <div class="hg-ai-actions">
            <label class="hg-ai-btn hg-ai-file" title="Adaugă o poză (opțional)">
              📷 Poză
              <input type="file" accept="image/*" data-hg-ai-file />
            </label>

            <button class="hg-ai-btn hg-ai-btn--primary" type="button" data-hg-ai-submit>
              Caută
            </button>

            <button class="hg-ai-btn hg-ai-btn--danger" type="button" data-hg-ai-close>
              Închide
            </button>
          </div>
        </div>

        <div class="hg-ai-body">
          <div class="hg-ai-left">
            <div class="hg-ai-sectionTitle">
              <strong>Rezultate rapide</strong>
              <span class="hg-ai-mini"><span data-hg-ai-count>0</span> rezultate</span>
            </div>

            <div class="hg-ai-list" data-hg-ai-list></div>
            <div class="hg-ai-empty" data-hg-ai-empty style="display:none;">
              Scrie ceva ca să vezi rezultate. Exemplu: “fungicid viță”, “îngrășământ roșii”, “mușchi în gazon”.
            </div>
          </div>

          <div class="hg-ai-right">
            <div class="hg-ai-sectionTitle">
              <strong>Răspuns AI</strong>
              <a class="hg-ai-link" href="/collections/all" data-hg-ai-shop-link>Magazin →</a>
            </div>

            <div class="hg-ai-aiBox">
              <div class="hg-ai-aiHead">
                <div>
                  <div class="hg-ai-aiTitle">Recomandare & pași</div>
                  <div class="hg-ai-aiNote">
                    Tip: adaugă <b>cultura</b> + <b>stadiu</b> + <b>simptome</b> + <b>suprafață</b> + <b>județ</b>.
                    Poză = și mai precis (dacă endpoint-ul o suportă).
                  </div>
                </div>
                <div class="hg-ai-status" data-hg-ai-status>
                  <span class="hg-ai-dot" data-hg-ai-dot></span>
                  gata
                </div>
              </div>

              <div class="hg-ai-preview" data-hg-ai-preview>
                <img data-hg-ai-preview-img alt="Poză încărcată" />
                <div class="hg-ai-previewBar">
                  <span data-hg-ai-preview-name></span>
                  <button class="hg-ai-link" type="button" data-hg-ai-clear-img>Șterge</button>
                </div>
              </div>

              <div class="hg-ai-output" data-hg-ai-output>
                Scrie o întrebare și primești:
                • rezultate rapide (produse/pagini)
                • răspuns AI (dacă endpoint-ul răspunde)
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(overlay);
    document.body.appendChild(modal);

    if (window.HG_AI_SEARCH_ENDPOINT) CFG.aiEndpoint = String(window.HG_AI_SEARCH_ENDPOINT);
    if (window.HG_AI_SEARCH_SHOP_BASE) CFG.shopBase = String(window.HG_AI_SEARCH_SHOP_BASE);

    try {
      const root = qs(modal, "[data-hg-ai-root]");
      const shopLink = qs(root, CFG.aiShopLinkSel);
      if (shopLink && CFG.shopBase) shopLink.href = CFG.shopBase;
    } catch (_) {}
  }

  function open() {
    ensureShell();
    if (isOpen()) return;

    const overlay = getOverlay();
    const modal = getModal();
    if (!overlay || !modal) return;

    lastActiveEl = document.activeElement;

    overlay.classList.add("is-open");
    modal.classList.add("is-open");
    overlay.setAttribute("aria-hidden", "false");

    lockScroll(true);

    const root = qs(modal, "[data-hg-ai-root]");
    const input = root ? qs(root, CFG.inputSel) : null;

    requestAnimationFrame(() => {
      setTimeout(() => {
        if (!input) return;
        try { input.focus({ preventScroll: true }); } catch (_) { input.focus(); }
      }, 60);
    });
  }

  function close() {
    const overlay = getOverlay();
    const modal = getModal();
    if (!overlay || !modal || !isOpen()) return;

    shieldOn(280);

    try {
      const input = modal.querySelector(CFG.inputSel);
      if (input) input.blur();
    } catch (_) {}
    try { if (document.activeElement) document.activeElement.blur(); } catch (_) {}

    overlay.classList.remove("is-open");
    modal.classList.remove("is-open");
    overlay.setAttribute("aria-hidden", "true");

    lockScroll(false);

    if (lastActiveEl && typeof lastActiveEl.focus === "function") {
      setTimeout(() => {
        try { lastActiveEl.focus({ preventScroll: true }); } catch (_) { lastActiveEl.focus(); }
      }, 0);
    }
    lastActiveEl = null;
  }

  function setStatus(root, mode, text) {
    const status = qs(root, CFG.statusSel);
    if (!status) return;
    const label = text || "gata";
    status.innerHTML = `<span class="hg-ai-dot ${mode === "live" ? "is-live" : ""}"></span> ${label}`;
  }

  // -----------------------------
  // Shopify Suggest (fast)
  // -----------------------------
  async function fetchSuggest(query) {
    const url = new URL("/search/suggest.json", window.location.origin);
    url.searchParams.set("q", query);
    url.searchParams.set("resources[type]", "product,collection,page,article");
    url.searchParams.set("resources[limit]", "8");
    url.searchParams.set("resources[options][unavailable_products]", "last");
    url.searchParams.set("resources[options][fields]", "title,product_type,variants.title");

    const res = await fetch(url.toString(), { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error("Suggest failed");
    return res.json();
  }

  function normalizeSuggest(data) {
    const out = [];
    const r = data && data.resources && data.resources.results ? data.resources.results : {};
    const pushList = (arr, type) => {
      (arr || []).forEach((x) => {
        out.push({
          type,
          title: x.title || "",
          url: x.url || "#",
          image: x.image || null,
          extra: x.product_type || x.type || ""
        });
      });
    };
    pushList(r.products, "Produs");
    pushList(r.collections, "Colecție");
    pushList(r.pages, "Pagină");
    pushList(r.articles, "Articol");
    return out;
  }

  // -----------------------------
  // HG Feed Search (descriere + tags)
  // -----------------------------
 const HG_CACHE_KEY = "hg_ai_feed_cache_v3";
const HG_CACHE_TS = "hg_ai_feed_cache_ts_v3";


  const HG_TTL = 6 * 60 * 60 * 1000;

  function hgStripDia(s) {
    return String(s || "")
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      .replace(/ș/g, "s").replace(/Ş/g, "s")
      .replace(/ț/g, "t").replace(/Ţ/g, "t")
      .replace(/ă/g, "a").replace(/Ă/g, "a")
      .replace(/â/g, "a").replace(/Â/g, "a")
      .replace(/î/g, "i").replace(/Î/g, "i");
  }

  function hgNorm(s) {
    // SAFE: fără \p{L}
    return hgStripDia(s)
      .toLowerCase()
      .replace(/\u00A0/g, " ")
      .replace(/[^a-z0-9\s-]/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function hgTok(q) {
    const n = hgNorm(q);
    if (!n) return [];
    return n.split(" ").filter(Boolean).slice(0, 8);
  }

  async function hgFetchFeed() {
  const now = Date.now();
  try {
    const ts = Number(sessionStorage.getItem(HG_CACHE_TS) || "0");
    const cached = sessionStorage.getItem(HG_CACHE_KEY);
    if (cached && ts && (now - ts) < HG_TTL) {
      const arr = JSON.parse(cached);
      if (Array.isArray(arr)) return arr;
    }
  } catch (_) {}

  // IMPORTANT: incarcam mai multe pagini din /collections/all
  const all = [];
  const perPage = 250;
  const maxPages = 12; // 12 * 250 = 3000 produse (suficient pentru majoritatea magazinelor)

  for (let page = 1; page <= maxPages; page++) {
    const url = new URL(CFG.hgFeedUrl, window.location.origin);
    // CFG.hgFeedUrl e "/collections/all?view=hg-search"
    url.searchParams.set("view", "hg-search");
    url.searchParams.set("page", String(page));

    const res = await fetch(url.toString(), { credentials: "same-origin" });
    if (!res.ok) break;

    let data = [];
    try { data = await res.json(); } catch (_) { break; }

    if (!Array.isArray(data) || !data.length) break;

    all.push(...data);

    // daca pagina are sub 250 produse, inseamna ca e ultima
    if (data.length < perPage) break;
  }

  try {
    sessionStorage.setItem(HG_CACHE_KEY, JSON.stringify(all));
    sessionStorage.setItem(HG_CACHE_TS, String(now));
  } catch (_) {}

  return all;
}


  function hgScore(p, tokens) {
    const title = hgNorm(p.title);
    const tags  = hgNorm(p.tags);
    const text  = hgNorm(p.text);

    let s = 0;
    for (const t of tokens) {
      if (!t) continue;

      if (title.indexOf(t) !== -1) s += 6;
      if (tags.indexOf(t) !== -1)  s += 4;
      if (text.indexOf(t) !== -1)  s += 2;

      if (t.length >= 4) {
        const stem = t.slice(0, t.length - 1);
        if (stem && title.indexOf(stem) !== -1) s += 1;
        if (stem && tags.indexOf(stem) !== -1)  s += 1;
        if (stem && text.indexOf(stem) !== -1)  s += 1;
      }
    }
    if (s > 0) s += Math.min(tokens.length, 4);
    return s;
  }

  async function hgSearchProducts(q) {
    const tokens = hgTok(q);
    if (!tokens.length) return [];

    const feed = await hgFetchFeed();
    if (!feed.length) return [];

    const scored = feed
      .map((p) => ({ p, s: hgScore(p, tokens) }))
      .filter((x) => x.s > 0)
      .sort((a, b) => b.s - a.s)
      .slice(0, CFG.hgLimit)
      .map((x) => x.p);

    return scored.map((p) => ({
      type: "Produs",
      title: p.title || "",
      url: p.url || "#",
      image: p.image || null,
      extra: "din descriere"
    }));
  }

  // -----------------------------
  // Render
  // -----------------------------
  function renderResults(root, items) {
    const list = qs(root, CFG.listSel);
    const empty = qs(root, CFG.emptySel);
    const count = qs(root, CFG.countSel);
    if (!list || !empty || !count) return;

    count.textContent = String(items.length || 0);

    if (!items.length) {
      list.innerHTML = "";
      empty.style.display = "";
      return;
    }
    empty.style.display = "none";

    list.innerHTML = items.map((it) => {
      const img = it.image
        ? `<img src="${esc(it.image)}" alt="${esc(it.title)}" loading="lazy">`
        : `<span aria-hidden="true">🔎</span>`;
      const sub = it.extra ? esc(it.extra) : it.type;

      return `
        <a class="hg-ai-item" href="${esc(it.url)}">
          <div class="hg-ai-thumb">${img}</div>
          <div class="hg-ai-meta">
            <div class="hg-ai-name">${esc(it.title)}</div>
            <div class="hg-ai-sub">${esc(sub)}</div>
          </div>
          <div class="hg-ai-pill">${esc(it.type)}</div>
        </a>
      `;
    }).join("");
  }

  // -----------------------------
  // AI call (unchanged)
  // -----------------------------
  async function callAI({ prompt, imageDataUrl }) {
    const payload = { prompt: prompt || "" };
    if (imageDataUrl && imageDataUrl.startsWith("data:image/")) payload.image = imageDataUrl;

    const res = await fetch(CFG.aiEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload)
    });

    const ct = res.headers.get("content-type") || "";
    if (ct.includes("application/json")) {
      const j = await res.json();
      return j.answer || j.response || j.message || j.output || JSON.stringify(j, null, 2);
    }
    return res.text();
  }

  // -----------------------------
  // Suggest + HG merge
  // -----------------------------
  async function runSuggest(root, q) {
    if (!q) {
      renderResults(root, []);
      return;
    }
    try {
      setStatus(root, "live", "căutare…");

      const data = await fetchSuggest(q);
      const items = normalizeSuggest(data);

      let extra = [];
      try { extra = await hgSearchProducts(q); } catch (_) {}

      // dedupe by url
      const seen = new Set((items || []).map((x) => x.url));
      const merged = (items || []).concat((extra || []).filter((x) => x.url && !seen.has(x.url)));

      renderResults(root, merged);
      setStatus(root, "idle", "gata");
    } catch (err) {
      console.warn(err);
      renderResults(root, []);
      setStatus(root, "idle", "gata");
    }
  }

  async function runSearch(root, q, alsoAI) {
    const out = qs(root, CFG.outputSel);
    if (!out) return;

    await runSuggest(root, q);

    if (!alsoAI) return;
    if (!q && !(root.__hgAiImage && root.__hgAiImage.dataUrl)) {
      out.textContent = "Scrie o întrebare sau adaugă o poză.";
      return;
    }

    const image = root.__hgAiImage && root.__hgAiImage.dataUrl ? root.__hgAiImage.dataUrl : null;
    const prompt = q || "Analizează poza și spune-mi problema + soluția recomandată + produse (dacă poți).";

    try {
      setStatus(root, "live", "AI…");
      out.textContent = "Se generează răspunsul…";
      const ans = await callAI({ prompt, imageDataUrl: image });
      out.textContent = ans ? String(ans).trim() : "Nu am primit un răspuns.";
      setStatus(root, "idle", "gata");
    } catch (err) {
      console.warn(err);
      setStatus(root, "idle", "gata");
      out.textContent =
        "AI nu a răspuns (sau endpoint-ul nu acceptă imagine). " +
        "Poți folosi rezultatele rapide din stânga sau încearcă doar text.";
    }
  }

  const debouncedSuggest = debounce(async (root, q) => {
    await runSuggest(root, q);
  }, 220);

  function setPreview(root, fileName, dataUrl) {
    const box = qs(root, CFG.previewSel);
    const img = qs(root, CFG.previewImgSel);
    const name = qs(root, CFG.previewNameSel);
    if (!box || !img || !name) return;

    if (!dataUrl) {
      box.classList.remove("is-on");
      img.removeAttribute("src");
      name.textContent = "";
      return;
    }
    img.src = dataUrl;
    name.textContent = fileName || "imagine";
    box.classList.add("is-on");
  }

  function readFileAsDataURL(file) {
    return new Promise((resolve, reject) => {
      const r = new FileReader();
      r.onload = () => resolve(String(r.result || ""));
      r.onerror = reject;
      r.readAsDataURL(file);
    });
  }

  function wire() {
    // Shield: block iOS ghost click that can trigger navigation
    document.addEventListener("click", (e) => {
      if (!shieldActive()) return;
      e.preventDefault();
      e.stopPropagation();
    }, true);

    document.addEventListener("pointerup", (e) => {
      if (!shieldActive()) return;
      e.preventDefault();
      e.stopPropagation();
    }, true);

    // Open
    document.addEventListener("click", (e) => {
      const btn = e.target && e.target.closest ? e.target.closest(CFG.openSel) : null;
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      open();
    }, true);

    // Esc + Ctrl/Cmd+K
    document.addEventListener("keydown", (e) => {
      const key = (e.key || "").toLowerCase();
      const meta = e.metaKey || e.ctrlKey;

      if (meta && key === "k") {
        e.preventDefault();
        open();
        return;
      }
      if (e.key === "Escape" && isOpen()) {
        e.preventDefault();
        close();
      }

      if (shieldActive() && (e.key === "Enter" || e.keyCode === 13)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    // Close on outside click
    document.addEventListener("pointerdown", (e) => {
      if (!isOpen()) return;

      const overlay = getOverlay();
      const modal = getModal();
      const panel = modal ? modal.querySelector(CFG.panelSel) : null;

      if (e.target === overlay || (panel && !panel.contains(e.target))) {
        e.preventDefault();
        e.stopPropagation();
        close();
      }
    }, true);

    // Inside modal actions
    document.addEventListener("click", async (e) => {
      if (!isOpen()) return;

      const modal = getModal();
      const root = modal ? qs(modal, "[data-hg-ai-root]") : null;
      if (!root) return;

      if (e.target.closest(CFG.closeSel)) {
        e.preventDefault();
        e.stopPropagation();
        close();
        return;
      }

      if (e.target.closest(CFG.clearImgSel)) {
        e.preventDefault();
        e.stopPropagation();
        root.__hgAiImage = null;
        setPreview(root, "", "");
        return;
      }

      if (e.target.closest(CFG.submitSel)) {
        e.preventDefault();
        e.stopPropagation();
        const input = qs(root, CFG.inputSel);
        const q = (input && input.value ? input.value : "").trim();
        await runSearch(root, q, true);
      }
    }, true);

    // Typing suggest
    document.addEventListener("input", (e) => {
      if (!isOpen()) return;
      const modal = getModal();
      const root = modal ? qs(modal, "[data-hg-ai-root]") : null;
      if (!root) return;

      const input = e.target && e.target.closest ? e.target.closest(CFG.inputSel) : null;
      if (!input) return;

      const q = (input.value || "").trim();
      debouncedSuggest(root, q);
    }, true);

    // Enter in input -> search (never submit)
    document.addEventListener("keydown", (e) => {
      if (!isOpen()) return;
      const modal = getModal();
      const root = modal ? qs(modal, "[data-hg-ai-root]") : null;
      if (!root) return;

      const input = e.target && e.target.closest ? e.target.closest(CFG.inputSel) : null;
      if (!input) return;

      if (e.key === "Enter") {
        e.preventDefault();
        e.stopPropagation();
        const q = (input.value || "").trim();
        runSearch(root, q, true);
      }
    }, true);

    // Block any submit while open
    document.addEventListener("submit", (e) => {
      if (!isOpen()) return;
      e.preventDefault();
      e.stopPropagation();
    }, true);

    // File upload
    document.addEventListener("change", async (e) => {
      if (!isOpen()) return;

      const modal = getModal();
      const root = modal ? qs(modal, "[data-hg-ai-root]") : null;
      if (!root) return;

      const fileInput = e.target && e.target.closest ? e.target.closest(CFG.fileSel) : null;
      if (!fileInput) return;

      const f = fileInput.files && fileInput.files[0];
      if (!f) return;

      if (f.size > 6 * 1024 * 1024) {
        alert("Imaginea e cam mare (max ~6MB). Te rog încarcă una mai mică.");
        fileInput.value = "";
        return;
      }

      try {
        const dataUrl = await readFileAsDataURL(f);
        root.__hgAiImage = { name: f.name, dataUrl };
        setPreview(root, f.name, dataUrl);
      } catch (err) {
        console.warn(err);
        alert("Nu am putut citi imaginea.");
      } finally {
        fileInput.value = "";
      }
    }, true);
  }

  ensureShell();
  wire();
})();
